import React, { useRef, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import facilitiesIcon from '../images/facilitiesIcon.jpg';
import environmentHandIcon from '../images/environmentHandIcon.jpg';
import recycleIcon from '../images/recycleIcon.jpg';
import lightGreenIcon from '../images/lightGreenIcon.jpg';
import midGreenIcon from '../images/midGreenIcon.jpg';
import darkGreenIcon from '../images/darkGreenIcon.jpg';
import environmentImage from '../images/forest-653448.jpg';
import cradleImage from '../images/_DSF5993-HDR.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import GreenChart from '../components/GreenChart';
import './Pages.css';

export default function Environment()
{
	localStorage.setItem('activeLinkIndex', '5');

	const navigate = useNavigate();
	const [activeSection, setActiveSection] = useState('section1');
  const [userClicked, setUserClicked] = useState(false);
  const leftArrowRef = useRef(null);
  const rightArrowRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!userClicked) {
        const sections = document.querySelectorAll('.section');
        sections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          const isNearTop = rect.top <= 120 && rect.bottom >= 0;
          if (isNearTop) {
            setActiveSection(section.id);
          }
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [userClicked]);

  const scrollToSection = (sectionId, offset) => 
  {
    const section = document.getElementById(sectionId);
    setUserClicked(true); // Set the flag when a user clicks a menu item
    const offsetTop = section.offsetTop - offset;
	window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    setTimeout(() => {
      setUserClicked(false); // Reset the flag after a delay
    }, 1000); // Adjust the delay as needed
  };

	return (
		<>
		<Container fluid>
			<div className='subMenu'>
				<ul>
					<li 
						onClick={() => { scrollToSection('section1', 90);
										for (let i = 0; i <= 1; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[0].classList.add('active');
				}}>
						<span className={`subMenuItem ${activeSection === 'section1' ? 'active' : ''}`}>Climate Reduction</span>
					</li>
					<li 
						onClick={() =>{ scrollToSection('section2', 90); 	    
										for (let i = 0; i <= 1; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[1].classList.add('active');
				}}><span className={`subMenuItem ${activeSection === 'section2' ? 'active' : ''}`}>Office Operations and Metrics</span></li>
				</ul>
			</div>
			<div className='contentArea sub'>
				<Row className='headerRow'>
					<h1 data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>Environment</h1>
				</Row>
				<hr/>
				<Row className='gx-5'>
					<Col lg={6}>
	         <div className='stat'>
							<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
								<img alt='An icon of a building.' src={recycleIcon} style={{width: '75%'}} />
							</div>
							<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight'>
							<span className="infographicHeading">Optimized</span>
					    <br/>
					    <span className='infographicSubHeading'>operational footprint</span>
							</div>
					</div>
					<div className='stat'>
							<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
								<img alt='An icon of a hand holding a plant.' src={environmentHandIcon} style={{width: '75%'}} />
							</div>
							<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight'>
							<span className="infographicHeading">Minimized</span>
					    <br/>
					    <span className='infographicSubHeading'>energy demand</span>
							</div>
					</div>
					<div className='stat'>
							<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
								<img alt='An icon of the recycle logo.' src={facilitiesIcon} style={{width: '75%'}} />
							</div>
							<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight'>
							<span className="infographicHeading">Modernized</span>
					    <br/>
					    <span className='infographicSubHeading'>facility systems</span>
							</div>
					</div>
					<p className='callOutParagraph' data-aos='zoom-in' data-aos-duration='750' data-aos-once='true'>Supporting our planet means reducing our environmental impact however we can.</p>
	        <br/>
					<p>We are committed to sustainable practices in each of our 159 facilities across our leased real estate portfolio. Our comprehensive Environmental, Health, and Safety (EHS) policy reflects our pledge to operating in a manner that protects our employees, partners, customers, and communities.</p>
					<p>In accordance with industry best practices, we submitted our disclosure through CDP (formerly the Carbon Disclosure Project), a not-for-profit charity that runs the global disclosure system for investors, companies, cities, states, and regions to manage their environmental impacts. This ensures transparency on climate issues and their impact.</p>
					<p>In recognition of Earth Day 2024, CACI partnered with the nonprofit One Tree Planted to support reforestation efforts in areas of need. This 501(c) (3) non-governmental organization is dedicated to combating deforestation and improving ecosystems across the planet. Thanks to our generous employees, we funded the planting of more than 1,000 trees across North America, South America, and Africa. We hope to build on this success and continue this campaign in 2025.</p>
					</Col>
					<Col lg={6}>
						<img alt='Grass blades in the middle of a forest.' data-aos='fade-left' data-aos-duration='750' data-aos-once='true' src={environmentImage} style={{width: '100%'}} />
					</Col>
				</Row>
				<br/>
				<Row>
					<Col>
						<h2 id='section1' className='mt-5 mb-4 section'>Climate reduction</h2>
						<p>We reduce our greenhouse gas (GHG) emissions through a variety of strategies, including:</p>
						<ul>
							<li>Effective use of real estate, including closing and consolidating locations as needed.</li>
							<li>Enrolling applicable facilities in renewable energy credit programs with utility providers, helping us offset carbon-intensive energy use with carbon-neutral renewable energy.</li>
							<li>Reducing energy waste by mitigating standby power consumption from idle devices and systems.</li>
							<li>Expanding renewable energy use through retrofitted LED lighting systems and energy-efficient HVAC systems.</li>
							<li>Technology and network support enhancements, including upgrades to energy-efficient equipment and cloud-based IT service delivery.</li>
							<li>Workforce education to reduce individual carbon footprints.</li>
						</ul>
						<br/>
						<p>We strive to reduce the environmental impact of commuting and business travel by:</p>
						<ul>
							<li>Encouraging and supporting alternatives to single-rider vehicles via a commuter incentive program that provides financial benefits to employees who choose alternative travel methods.</li>
							<li>Promoting flexible work arrangements to limit commuter impact.</li>
							<li>Reducing business travel GHG emissions through more efficient business processes and enhanced telecommunications equipment.</li>
						</ul>
					</Col>
				</Row>
				<br/>
				<Row>
					<Col>
							<div className='table-container mt-lg-5' data-aos='fade-up' data-aos-duration='750' data-aos-once='true' style={{backgroundColor: '#f2f2f2', padding: '15px'}}>
							<Table className='environmentTable'>
								<thead>
									<tr>
										<th colSpan='5' style={{borderBottom: '0', fontWeight: '300', fontSize: '1.5rem'}}>
											Greenhouse gas emissions<sup>**</sup>
										</th>
									</tr>
									<tr>
										<th colSpan='1' style={{borderBottom: '0'}}></th>
										<th colSpan='4' className='text-center' style={{borderBottom: '0', fontWeight: '300'}}>Emissions (MT CO<sub>2</sub>e)</th>
									</tr>
									<tr style={{fontWeight: '800', borderBottom: '3px solid #4D4D4D'}}>
										<td style={{minWidth: '160px'}}>Emission Sources</td>
										<td className='text-end'>CY 2021</td>
										<td className='text-end'>CY 2022</td>
										<td className='text-end'>CY 2023</td>
										<td className='text-end'>CY 2024</td>
									</tr>
								</thead>
								<tbody style={{borderColor: '#000'}}>
									<tr style={{color: '#fff', backgroundColor: '#5F687A'}}>
										<td><strong>Scope 1</strong></td>
										<td className='text-end'>3,548.00</td>
										<td className='text-end'>4,337.46</td>
										<td className='text-end'>4,012.22</td>
										<td className='text-end'>3,648.35</td>
									</tr>
									<tr>
										<td>Mobile Combustion</td>
										<td className='text-end'>788.20</td>
										<td className='text-end'>1,157.25</td>
										<td className='text-end'>1,056.47</td>
										<td className='text-end'>849.10</td>
									</tr>
									<tr>
										<td>Refrigerants</td>
										<td className='text-end'>969.70</td>
										<td className='text-end'>770.51</td>
										<td className='text-end'>906.88</td>
										<td className='text-end'>775.75</td>
									</tr>
									<tr>
										<td>Stationary Combustion</td>
										<td className='text-end'>1,790.10</td>
										<td className='text-end'>2,409.70</td>
										<td className='text-end'>2,048.89</td>
										<td className='text-end'>2,023.50</td>
									</tr>
									<tr style={{color: '#fff', backgroundColor: '#5F687A'}}>
										<td><strong>Scope 2</strong></td>
										<td className='text-end'>26,152.00</td>
										<td className='text-end'>25,906.04</td>
										<td className='text-end'>21,970.65</td>
										<td className='text-end'>19,614.23</td>
									</tr>
									<tr>
										<td>Electricity</td>
										<td className='text-end'>26,152.00</td>
										<td className='text-end'>25,906.04</td>
										<td className='text-end'>21,970.65</td>
										<td className='text-end'>19,614.23</td>
									</tr>
									<tr style={{color: '#fff', backgroundColor: '#5F687A'}}>
										<td><strong>Scope 3</strong><sup>*</sup></td>
										<td></td>
										<td className='text-end'>17,535.02</td>
										<td className='text-end'>246,945.90</td>
										<td className='text-end'>244,381.35</td>
									</tr>
									<tr>
										<td>Business Travel</td>
										<td className='text-end'>-</td>
										<td className='text-end'>17,535.02</td>
										<td className='text-end'>15,015.28</td>
										<td className='text-end'>3,693.08</td>
									</tr>
									<tr>
										<td>Employee Commuting</td>
										<td className='text-end'>-</td>
										<td className='text-end'>-</td>
										<td className='text-end'>36,296.02</td>
										<td className='text-end'>35,695.58</td>
									</tr>
									<tr>
										<td>Purchased Goods and Services</td>
										<td className='text-end'>-</td>
										<td className='text-end'>-</td>
										<td className='text-end'>195,634.60</td>
										<td className='text-end'>194,992.69</td>
									</tr>
									<tr style={{borderBottom: '1px solid #f2f2f2'}}>
										<td className='text-end'><strong>Grand Total</strong></td>
										<td className='text-end'><strong>29,700.00</strong></td>
										<td className='text-end'><strong>47,778.52</strong></td>
										<td className='text-end'><strong>272,928.77</strong></td>
										<td className='text-end'><strong>267,643.93</strong></td>
									</tr>
									<tr>
										<td style={{fontSize: '0.75rem', borderBottom: '1px solid #f2f2f2', fontWeight: '300'}}><sup>*</sup>Employee commuting and purchased goods and services were not compiled metrics in calendar years prior to 2023.<br/><sup>**</sup>GHG data is submitted to CACI each calendar year, not each fiscal year.</td>
									</tr>
								</tbody>
							</Table>
						</div>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5'>
					<Col lg={6}>
						<h3 className='mt-5 mb-4'>Material use and waste</h3>
						<p>We commit to conservation and environmental stewardship by integrating recycled materials into our operations and encouraging our suppliers and partners across the supply chain to follow suit.</p>
						<p>CACI’s sustainable shipping and packaging policy ensures our suppliers:</p>
						<ul>
							<li>Promote sustainability by adhering to environmental protection ordinances and complying with applicable federal, state, and local laws and regulations.</li>
							<li>Meet defined minimum standards.</li>
							<li>Use eco-friendly packaging that prioritizes recycled or reusable packaging materials.</li>
							<li>Adopt energy-efficient and economical shipping methods that minimize carbon footprints.</li>
						</ul>
						<h3 id='section2' className='mt-5 mb-4 section'>Office operations and metrics</h3>
						<p>We work with vendors to acquire eco-friendly office products. Our green spend reflects our progress through the innovative eco-rating system of ODP Business Solutions. This year marks the first year more than half of our total office supply spend was green, indicative of our commitment to sustainable office materials.</p>
					</Col>
					<Col lg={6}>
						<div className='table-container mt-lg-5' data-aos='fade-up' data-aos-duration='750' data-aos-once='true' style={{backgroundColor: '#f2f2f2', padding: '15px', overflow: 'hidden'}}>
						<Table className='greenTable'>
							<thead>
								<tr>
									<td colSpan='3' style={{borderBottom: '4px solid #000', fontWeight: '600', padding: '0'}}>Green Spend</td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style={{borderBottom: '1px solid grey'}}>Light Green Spend</td>
									<td style={{borderBottom: '1px solid grey'}}>$815,084</td>
									<td style={{borderBottom: '1px solid grey'}}>40.94%</td>
								</tr>
								<tr>
									<td style={{borderBottom: '1px solid grey'}}>Mid Green Spend</td>
									<td style={{borderBottom: '1px solid grey'}}>$292,751</td>
									<td style={{borderBottom: '1px solid grey'}}>14.70%</td>
								</tr>
								<tr>
									<td style={{borderBottom: '1px solid grey'}}>Dark Green Spend</td>
									<td style={{borderBottom: '1px solid grey'}}>$9,518</td>
									<td style={{borderBottom: '1px solid grey'}}>0.48%</td>
								</tr>
								<tr>
									<td style={{borderBottom: '2px solid grey'}}>Total Green Spend</td>
									<td style={{borderBottom: '2px solid grey'}}>$1,117,353</td>
									<td style={{borderBottom: '2px solid grey'}}>56.12%</td>
								</tr>
								<tr>
									<td style={{borderBottom: 'none'}}>Total Spend</td>
									<td style={{borderBottom: 'none'}}>$1,991,025</td>
									<td style={{borderBottom: 'none'}}>100.00%</td>
								</tr>
							</tbody>
						</Table>
						<span className='mt-lg-5' data-aos='fade-up' data-aos-duration='750' data-aos-once='true' style={{borderBottom: '4px solid #000', fontWeight: '700', paddingBottom: '4px', lineHeight: '30px'}}>Category Purchases by ODP Business Solutions GreenerOffice<sup>TM</sup> Eco-rating</span>
						<GreenChart />
						<span className='chartLegendSpan'>Measures</span>
						<br/>
						<Row>
							<Col lg={4}>
								<div className='stat'>
									<div className='statFloatLeft'>
											<img alt='An icon of a plant with a light green background.' src={lightGreenIcon} style={{width: '100%'}}/>
										</div>
									<div className='statFloatRight'>
										<span style={{color: '#c1d730', fontSize: '0.75rem', fontWeight: '600'}}>LIGHT GREEN</span>
										<br/>
										<p style={{fontSize: '0.65rem'}}>Products with at least one meaningful eco-attribute or eco-label</p>
									</div>
								</div>
							</Col>
							<Col lg={4}>
									<div className='stat'>
										<div className='statFloatLeft'>
												<img alt='An icon of a plant with a medium green background.' src={midGreenIcon} style={{width: '100%'}}/>
											</div>
										<div className='statFloatRight'>
											<span style={{color: '#6db341', fontSize: '0.75rem', fontWeight: '600'}}>MID GREEN</span>
											<br/>
											<p style={{fontSize: '0.65rem'}}>Products with a high level of one or more meaningful eco-attributes/eco-labels</p>
										</div>
									</div>
							</Col>
								<Col lg={4}>
									<div className='stat'>
										<div className='statFloatLeft'>
												<img alt='An icon of a plant with a dark green background.' src={darkGreenIcon} style={{width: '100%'}}/>
											</div>
										<div className='statFloatRight'>
											<span style={{color: '#04703c', fontSize: '0.75rem', fontWeight: '600'}}>DARK GREEN</span>
											<br/>
											<p style={{fontSize: '0.65rem'}}>Products with the highest level of one or more meaningful eco-attributes/eco-labels</p>
										</div>
									</div>
							</Col>
						</Row>
						</div>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5 pb-5'>
					<Col lg={6}>
					<h3 className='mt-5 mb-4'>Energy consumption</h3>
						<p>Our design and renovation projects promote clean work environments with standard Energy Star-Certified appliances.</p>
						<p>New facilities use energy-efficient LED lighting that meets applicable energy codes. Occupancy sensors and dimming systems reduce energy usage, extend the life of light fixtures, and reduce landfill waste.</p>
						<p>Existing furniture and fixtures are repurposed where possible, as are select carpets, floors, and solid surface materials that are high in pre- and post-consumer recycled content. Carpet in new facilities is 100% PVC-free, recyclable, and Cradle-to-Cradle Certified<sup>TM</sup> at the LEED Silver level.</p>
					<h3 className='mt-5 mb-4'>Recycling</h3>
						<p>Our trash and recycling programs reduce the use of materials in shared spaces throughout the workplace. In FY 2025, we partnered with Iron Mountain to securely shred, salvage, and recycle over 77 tons of paper.</p>
					<h3 className='mt-5 mb-4'>Water</h3>
						<p>The water-efficient plumbing fixtures in the bathrooms, kitchens, and pantries of our new and renovated facilities meet low-flow water consumption requirements, demonstrating our commitment to reducing water waste.</p>
					</Col>
					<Col lg={6}>
						<img data-aos='fade-left' data-aos-duration='750' data-aos-once='true' src={cradleImage} alt='The server room in the CRADLE at CACI HQ' style={{width: '100%'}} />
						<div className='table-container mt-4' data-aos='fade-up' data-aos-duration='750' data-aos-once='true'>
						<Table className='mt-lg-5'>
							<thead>
								<tr>
									<td colSpan='3' style={{borderBottom: '4px solid #fff', fontWeight: '700'}}>Environmental metrics</td>
								</tr>
								<tr style={{borderBottom: '4px solid #000', fontWeight: '700', color: '#000'}}>
									<td>Category</td>
									<td className='text-center'>CY 2024</td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style={{borderBottom: '1px solid grey', maxWidth: '300px'}}>Locations</td>
									<td style={{borderBottom: '1px solid grey'}} className='text-center' >159</td>
								</tr>
								<tr>
									<td style={{borderBottom: '1px solid grey', maxWidth: '300px'}}>Building area</td>
									<td style={{borderBottom: '1px solid grey'}} className='text-center' >11,712,365 sq ft</td>
								</tr>
								<tr>
									<td style={{borderBottom: '1px solid grey', maxWidth: '300px'}}>Leased/tenure area</td>
									<td style={{borderBottom: '1px solid grey'}} className='text-center' >3,792,545 sq ft</td>
								</tr>
								<tr>
									<td style={{borderBottom: '1px solid grey', maxWidth: '300px'}}>Water usage</td>
									<td style={{borderBottom: '1px solid grey'}} className='text-center' >44,412,893 gallons</td>
								</tr>
							</tbody>
						</Table>
						</div>
					</Col>
				</Row>
			</div>
		<div style={{ clear: 'both' }}></div>
		</Container>
          <div className='navigationArrows'>
        <div ref={leftArrowRef} className='arrowContainer leftArrow' 
onTouchStart={() => {
                    leftArrowRef.current.classList.add('arrowTouchActive');
                }}
            onTouchEnd={() => {
                    leftArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/our-approach');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[4].classList.add('active');
              document.getElementsByClassName('underline')[4].classList.add('active');
            }}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </div>
        <div ref={rightArrowRef} className='arrowContainer rightArrow'
        onTouchStart={() => {
                    rightArrowRef.current.classList.add('arrowTouchActive');
                }}
            onTouchEnd={() => {
                    rightArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/social');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[6].classList.add('active');
              document.getElementsByClassName('underline')[6].classList.add('active');
            }}>
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </div>
		</>
	);
}